import React, { useState } from 'react';
import { Text } from '@cashfree-intl/coherent';
import Policy from './Policy';

const PolicyList = ({
  policyListData,
  handlePolicyList,
  handlePolicyListDelete,
  checkedItems,
  onSelectAllHandler,
  onClearAllHandler,
  filteredData,
  removeEvent,
  addEvent,
  handleFilterSearch,
  searchInput,
  existingWebhooks,
  endpointDetails,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const handleAccordianItemClick = index => {
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);
  };
  return (
    <>
      <Text variant="h16" strong>
        Endpoint Details
      </Text>
      <Text color="bodyLight" className="mt-1 mb-3">
        Add and customise retry policies as per your needs
      </Text>
      {policyListData.map((policyData, index) => (
        <React.Fragment key={index}>
          <Policy
            handleAccordianItemClick={handleAccordianItemClick}
            activeIndex={activeIndex}
            policyData={policyData}
            index={index}
            handlePolicyList={handlePolicyList}
            checkedItems={checkedItems}
            onSelectAllHandler={onSelectAllHandler}
            onClearAllHandler={onClearAllHandler}
            filteredData={filteredData}
            removeEvent={removeEvent}
            addEvent={addEvent}
            handleFilterSearch={handleFilterSearch}
            searchInput={searchInput}
            policyListLength={policyListData.length}
            handlePolicyListDelete={handlePolicyListDelete}
            existingWebhooks={existingWebhooks}
            endpointDetails={endpointDetails}
          />
        </React.Fragment>
      ))}
    </>
  );
};

export default PolicyList;
